export const Set_Data = "Set_Data";

export const Set_Home_Data = (home) => {
    return{
        type: Set_Data,
        home:home
    }
}

export const SET_RATES = "SET_RATES";
export const setRates = (CphRates, BillundRates) => ({
  type: SET_RATES,
  payload: { CphRates, BillundRates },
});

export const SET_CONTACT_COPENHAGEN = "SET_CONTACT_COPENHAGEN";
export const setContactCopenhagen = (contactData) => ({
  type: SET_CONTACT_COPENHAGEN,
  payload: contactData,
});

export const SET_CONTACT_BILLUND = "SET_CONTACT_BILLUND";
export const setContactBillund = (contactData) => ({
  type: SET_CONTACT_BILLUND,
  payload: contactData,
});

export const SET_SERVICES = "SET_SERVICES";
export const setServices = (services) => ({
  type: SET_SERVICES,
  payload: services,
});

export const SET_FAQ = "SET_FAQ";
export const setFaq = (faq) => ({
  type: SET_FAQ,
  payload: faq,
});

export const SET_LOCATION = "SET_LOCATION";
export const setLocation = (location) => ({
  type: SET_LOCATION,
  payload: location,
});

export const SET_ABOUT_US_BANNER = "SET_ABOUT_US_BANNER";
export const setAboutUsBanner = (banner) => ({
  type: SET_ABOUT_US_BANNER,
  payload: banner,
});

export const SET_ABOUT_US_CONTENT = "SET_ABOUT_US_CONTENT";
export const setAboutUsContent = (content) => ({
  type: SET_ABOUT_US_CONTENT,
  payload: content,
});

export const SET_CERTIFICATES = "SET_CERTIFICATES";
export const setCertificates = (certificates) => ({
  type: SET_CERTIFICATES,
  payload: certificates,
});

export const SET_HOMEPAGE_DATA = "SET_HOMEPAGE_DATA";
export const setHomepageData = (data) => ({
  type: SET_HOMEPAGE_DATA,
  payload: data,
});